import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { globalStyles } from '../../styles/global.styles';
import { ReactComponent as IconRocket } from '../../assets/iconRocket.svg';
import iconBubble from '../../assets/iconBubble.svg';
import { errorPageStyles } from './ErrorPage.styles';
import { CustomButton } from '../../components/atoms/CustomButton';
import { Link } from 'react-router-dom';
import { IErrorPage } from './ErrorPageTypes';
import errorPageTranslations from '../../common/utils/errorPageTranslations';
import { isKidsOrJunior } from '../../common/utils/activeMenus';

const ErrorPage: React.FC<IErrorPage> = ({ fatalError = false }) => {
	const language =
		localStorage.getItem('lang') !== null
			? localStorage.getItem('lang')
			: window?.navigator?.language
			? window.navigator.language.split('-')[0]
			: 'es';
	const globalClasses = globalStyles();
	const classes = errorPageStyles();
	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

	const renderLiteral = (language: string, literal: string) => {
		switch (language) {
			case 'ca':
				return errorPageTranslations[language][literal];
			case 'es':
				return errorPageTranslations[language][literal];
			default:
				return errorPageTranslations.es[literal];
		}
	};

	return (
		<Grid
			container
			direction='row'
			justifyContent='space-between'
			className={`${classes.content} ${isKidsOrJunior() && globalClasses.juniorKidsBack}`}
		>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				className={`${globalClasses.flexJustifyCenter}`}
			>
				<Typography
					className={`${globalClasses.fw600} ${globalClasses.fontSize42} ${globalClasses.mb20} ${isKidsOrJunior() && globalClasses.colorWhite}`}
				>
					{
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore
						renderLiteral(language, 'mybank:errorpage:ups')
					}
				</Typography>
			</Grid>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				className={
					isDesktop
						? `${globalClasses.flexJustifyCenter}`
						: `${globalClasses.flexDirectionColumn} ${globalClasses.alignItemsCenter}`
				}
			>
				{isDesktop && <IconRocket />}
				<div
					className={
						isDesktop
							? `${globalClasses.flexDirectionColumn} ${globalClasses.flexJustifyCenter} ${globalClasses.pl29}`
							: `${globalClasses.flexDirectionColumn} ${globalClasses.flexJustifyCenter} ${globalClasses.w90}`
					}
				>
					<div className={globalClasses.flexJustifyCenter}>
						<Typography
							className={`${globalClasses.pb16} ${globalClasses.fontSize18} ${globalClasses.textCenter} ${globalClasses.w430} ${globalClasses.fw700} ${globalClasses.flexAlignCenter} ${isKidsOrJunior() && globalClasses.colorWhite}`}
						>
							{fatalError
								? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
								  // @ts-ignore
								  renderLiteral(language, 'mybank:errorpage:errormsg:fatal')
								: // eslint-disable-next-line @typescript-eslint/ban-ts-comment
								  // @ts-ignore
								  renderLiteral(language, 'mybank:errorpage:errormsg')}
						</Typography>
					</div>
					<div className={`${globalClasses.flexJustifyCenter}`}>
						<div
							className={
								`${isDesktop ? classes.boxInfoWeb:classes.boxInfoMobil } ${isKidsOrJunior() && globalClasses.juniorKidShadow}`
							}
						>
							<div className={`${classes.boxRowIconText}`}>
								<img src={iconBubble} className={globalClasses.mr10} />
								<Typography
									className={`${classes.boxInfoText} ${isKidsOrJunior() && globalClasses.colorWhite}`}
									variant='body1'
								>
									{
										// eslint-disable-next-line @typescript-eslint/ban-ts-comment
										// @ts-ignore
										renderLiteral(language, 'mybank:errorpage:errormsg2')
									}
								</Typography>
							</div>
							<Typography
								component={'span'}
								className={`${globalClasses.textCenter} ${globalClasses.textBold} ${classes.contactPhone} ${isKidsOrJunior() && globalClasses.colorWhite}`}
							>
								{
									// eslint-disable-next-line @typescript-eslint/ban-ts-comment
									// @ts-ignore
									renderLiteral(language, 'mybank:errorpage:errortlf')
								}
							</Typography>
						</div>
					</div>
					{!fatalError ? (
						<div
							className={`${globalClasses.flexJustifyCenter} ${globalClasses.pt8} ${globalClasses.pb8}`}
						>
							<Link to={'/'} className={`${globalClasses.textNoUnderline} `}>
								<CustomButton
									buttonType={'backhome'}
									text={
										// eslint-disable-next-line @typescript-eslint/ban-ts-comment
										// @ts-ignore
										renderLiteral(language, 'mybank:errorpage:back-hometext')
									}
								/>
							</Link>
						</div>
					) : (
						<div
							className={`${globalClasses.flexJustifyCenter} ${globalClasses.pt8} ${globalClasses.pb8}`}
						>
							<CustomButton
								onClick={() => window.location.assign('/')}
								buttonType={'backhome'}
								text={
									// eslint-disable-next-line @typescript-eslint/ban-ts-comment
									// @ts-ignore
									renderLiteral(language, 'mybank:errorpage:back-hometext')
								}
							/>
						</div>
					)}
				</div>
				{!isDesktop && (
					<Grid item className={classes.rocketWrapper}>
						<IconRocket />
					</Grid>
				)}
			</Grid>
		</Grid>
	);
};

export default ErrorPage;
